import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { registerChannel, unregisterChannel } from "@/lib/realtimeChannels";

/** Live count of completed scans waiting on the user's review/keep/post
 *  decision. Used to gate the "To review" tile on the profile page. */
export function useReviewPendingCount(): number {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) { setCount(0); return; }
    let cancelled = false;
    const load = async () => {
      const { count: c } = await supabase
        .from("scans")
        .select("id", { count: "exact", head: true })
        .eq("user_id", user.id)
        .eq("processing_status", "complete")
        .eq("review_status", "pending");
      if (!cancelled) setCount(c ?? 0);
    };
    void load();
    const key = `review-pending-${user.id}`;
    registerChannel(key, () =>
      supabase
        .channel(key)
        .on("postgres_changes", { event: "*", schema: "public", table: "scans", filter: `user_id=eq.${user.id}` }, () => void load())
        .subscribe()
    );
    return () => { cancelled = true; unregisterChannel(key); };
  }, [user]);

  return count;
}